import React from 'react';

const PilComp: React.FC<{
  value: number | string;
  color?: string;
  style?: React.CSSProperties;
}> = ({value, color = '#98F2E1', style = {}}) => {
  const defaultStyles: React.CSSProperties = {
    padding: '2px 8px',
    width: 'fit-content',
    borderRadius: '20px',
    // height: '18px',
    backgroundColor: color,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500
    // color: '#fff'
    // lineHeight: '120%'
  };
  const mergedStyles = {
    ...defaultStyles,
    ...style
  };

  return <div style={mergedStyles}>{value}</div>;
};

export default PilComp;
